var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserFriendlyDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7833 54.375L16.1916 46.6417L7.49163 44.7083L8.33746 35.7667L2.41663 29L8.33746 22.2333L7.49163 13.2917L16.1916 11.3583L20.7833 3.625L29 7.12917L37.2166 3.625L41.8083 11.3583L50.5083 13.2917L49.6625 22.2333L55.5833 29L49.6625 35.7667L50.5083 44.7083L41.8083 46.6417L37.2166 54.375L29 50.8708L20.7833 54.375ZM22.8375 48.2125L29 45.5542L35.2833 48.2125L38.6666 42.4125L45.3125 40.8417L44.7083 34.075L49.1791 29L44.7083 23.8042L45.3125 17.0375L38.6666 15.5875L35.1625 9.7875L29 12.4458L22.7166 9.7875L19.3333 15.5875L12.6875 17.0375L13.2916 23.8042L8.82079 29L13.2916 34.075L12.6875 40.9625L19.3333 42.4125L22.8375 48.2125ZM26.4625 37.5792L40.1166 23.925L36.7333 20.4208L26.4625 30.6917L21.2666 25.6167L17.8833 29L26.4625 37.5792Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendlyDefault);
export default __webpack_public_path__ + "static/media/user-friendly-default.cb67cc63ff90e93d407f86dc207cbeb5.svg";
export { ForwardRef as ReactComponent };